import { reactive } from 'vue';

export const criarEpDocModelo = () => {
    return reactive({
        id: 0,
        idep: 0,
        idepmenudoc: 0,
        cdmodelo: '',
        nmepdocmodelo: '',
        nmmenu: '',
        nmrelatorio: '',
        informacoes: '',
        versao: '',
        versao_data: '',
        ativo: 'S',
        ckapp: 'N',
        ckweb: 'N',
        ckestabelecimento: 'N',
        cksim: 'N',
        idlogin: 0,
    })
}
